import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetConciergeUrl,
	GetConciergeUrlModel,
	GetConciergeUrlParams,
} from 'domain/usecases/private/home/concierge';

export class RemoteGetConciergeUrl implements GetConciergeUrl {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetConciergeUrlModel>,
	) {}

	async get({signal}: GetConciergeUrlParams): Promise<GetConciergeUrlModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
